import { useState } from 'react';
import { Box, Button, Card, CardContent, TextField, Typography } from '@mui/material';

export default function QuizQuestionCard({ question, options = [], selectedAnswer, correctAnswer,
  disabled = false, onAnswer }) {
  const [typedAnswer, setTypedAnswer] = useState('');
  return <Card sx={{ maxWidth: 600, mx: 'auto', mt: 5, boxShadow: 3, p: 2 }}>
    <CardContent>
      <Typography variant="h5" fontWeight="bold">{question}</Typography>
      {options.length ? <Box sx={{ mt: 3 }}>
        {options.map((option, i) => {
          const answered = selectedAnswer !== null && selectedAnswer !== undefined;
          const correct = answered && option === correctAnswer;
          const wrong = answered && option === selectedAnswer && !correct;
          return <Button key={i} fullWidth variant="contained" sx={{
            my: 1, textTransform: 'none',
            backgroundColor: correct ? '#4caf50' : wrong ? '#f44336' : undefined
          }} disabled={disabled || answered} onClick={() => onAnswer(option)}>{option}</Button>;
        })}
      </Box> : <Box sx={{ mt: 3 }}>
        <TextField fullWidth label="Your Answer" value={typedAnswer}
          onChange={e => setTypedAnswer(e.target.value)} disabled={disabled || selectedAnswer != null} />
        <Button variant="contained" sx={{ mt: 2 }} disabled={disabled || selectedAnswer != null || !typedAnswer.trim()}
          onClick={() => onAnswer(typedAnswer)}>Submit Answer</Button>
      </Box>}
    </CardContent>
  </Card>;
}
